import { fabric } from "fabric";
export enum AnnotationTypes {
	Rect,
	Circle,
	Star
}

export interface ShapeOptions {
	type: AnnotationTypes;
	width: number;
	height: number;
	x: number;
	y: number;
	color: string;
	rotate: number;
	fill: any;
	opacity: number;
}

export interface ShapeGetData {
	getData(): ShapeOptions;
	setData(options: Partial<ShapeOptions>): void;
}

export const AnnotationObjectDefaultProperties = {
	fill: "transparent",
	strokeWidth: 5,
	strokeUniform: true
};
